import * as React from "react";
import { Button } from "./ui/button";
import { Send, Mic, StopCircle } from "lucide-react";

interface ActionButtonProps {
  isRecording: boolean;
  isMicroLoading: boolean;
  isConverting: boolean;
  isSendingMessage: boolean;
  chatMessage: string;
  onMicClick: () => void;
  onSend: () => void;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  isRecording,
  isMicroLoading,
  isConverting,
  isSendingMessage,
  chatMessage,
  onMicClick,
  onSend,
}) => {
  if (isRecording || isMicroLoading) {
    return (
      <Button
        size="icon"
        variant="destructive"
        className="size-10 p-0"
        onClick={onMicClick}
        title="Stop recording"
        disabled={isSendingMessage}
      >
        <StopCircle />
      </Button>
    );
  }
  if (chatMessage.trim() === "") {
    return (
      <Button
        size="icon"
        variant="default"
        className="size-10 p-0"
        onClick={onMicClick}
        disabled={isMicroLoading || isConverting || isSendingMessage}
        title="Voice message"
      >
        <Mic />
      </Button>
    );
  }
  return (
    <Button
      size="icon"
      className="size-10 p-0"
      onClick={onSend}
      disabled={!chatMessage.trim() || isSendingMessage}
      title="Send message"
    >
      <Send />
    </Button>
  );
};

export { ActionButton };
